import { render, staticRenderFns } from "./DeployedWithErrorAlert.vue?vue&type=template&id=2228ad98"
import script from "./DeployedWithErrorAlert.vue?vue&type=script&lang=ts"
export * from "./DeployedWithErrorAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports